import RxDialog from "./RxDialog";

export default RxDialog;
